<div class="row" style="padding-left: 15px; padding-top: 10px">
    <h3><b>Citiservi MAIDs QA Report - {{selectedReport.date | date}}</b></h3>
</div>
<div class="row" style="padding-left: 15px; padding-top: 10px">
    <h3><b>General data</b></h3>
</div>
<div class="row" style="padding-left: 15px; padding-top: 10px">
    Total records: {{selectedReport.totalRecords | number:'':'es' }}
</div>
<div class="row" style="padding-left: 15px; padding-top: 10px">
    Total android records: {{selectedReport.totalAndroidRecords | number:'':'es' }}
</div>
<div class="row" style="padding-left: 15px; padding-top: 10px">
    Total ioS records: {{selectedReport.totalIOSRecords | number:'':'es' }}
</div>
<div class="row" style="padding-left: 15px; padding-top: 10px">
    Total records with hashed email: {{selectedReport.totalRecordsWithExternalId | number:'':'es' }}
</div>
<div class="row" style="padding-left: 15px; padding-top: 10px">
    Unique identities: {{selectedReport.uniqueIdentifiersRecords | number:'':'es' }}
</div>  
<div class="row">&nbsp;</div>
<div class="row" style="padding-left: 15px; padding-top: 10px">
    <h3><b>Anomalies</b></h3>
</div>
<div class="row" style="padding-left: 15px; padding-top: 10px">
    Identities with no segments (at least one identifier): {{selectedReport.identifiersNoSegmentsRecords | number:'':'es' }}
</div>               
<div class="row">&nbsp;</div>
<div class="row" style="padding-left: 15px; padding-top: 10px">
    <h4><b>Duplicated identities (more than one signal)</b></h4>
</div>
<div class="row" style="padding-left: 15px; padding-top: 10px">
    Number of identities with more than one signal: {{selectedReport.anomalies.duplicatedSignals.total | number:'':'es' }}
</div>      
<div class="row" style="padding-left: 15px; padding-top: 10px">
    Top 20 identities with more signals
</div>
<div class="row" style="padding-left: 15px; padding-top: 10px">
    <table class="table table-striped">
        <thead>
            <tr>
                <th scope="col">UID</th>
                <th scope="col">Number of signals</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let top20Item of selectedReport.anomalies.duplicatedSignals.top20; index as i">
                <td>{{ top20Item.uid }}</td>
                <td>{{ top20Item.count | number:'':'es' }}</td>
            </tr>
        </tbody>
    </table>        
</div>          
<div class="row">&nbsp;</div>
<div class="row" style="padding-left: 15px; padding-top: 10px">
    <h4><b>Identities with more than two home ids</b></h4>
</div>
<div class="row" style="padding-left: 15px; padding-top: 10px">
    Number of identities with more than two home ids: {{selectedReport.anomalies.identitiesWithMoreThan2HomeIds.total | number:'':'es' }}
</div>      
<div class="row" style="padding-left: 15px; padding-top: 10px">
    Top 20 identities with more home ids
</div>
<div class="row" style="padding-left: 15px; padding-top: 10px">
    <table class="table table-striped">
        <thead>
            <tr>
                <th scope="col">UID</th>
                <th scope="col">Number of home ids</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let top20Item of selectedReport.anomalies.identitiesWithMoreThan2HomeIds.top20; index as i">
                <td>{{ top20Item.uid }}</td>
                <td>{{ top20Item.count | number:'':'es' }}</td>
            </tr>
        </tbody>
    </table>        
</div>      
<!---->
<div class="row">&nbsp;</div>
<div class="row" style="padding-left: 15px; padding-top: 10px">
    <h4><b>Identities with more than two home zips</b></h4>
</div>
<div class="row" style="padding-left: 15px; padding-top: 10px">
    Number of identities with more than two home zips: {{selectedReport.anomalies.identitiesWithMoreThan2HomeZips.total | number:'':'es' }}
</div>      
<div class="row" style="padding-left: 15px; padding-top: 10px">
    Top 20 identities with more home zips
</div>
<div class="row" style="padding-left: 15px; padding-top: 10px">
    <table class="table table-striped">
        <thead>
            <tr>
                <th scope="col">UID</th>
                <th scope="col">Number of home zips</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let top20Item of selectedReport.anomalies.identitiesWithMoreThan2HomeZips.top20; index as i">
                <td>{{ top20Item.uid }}</td>
                <td>{{ top20Item.count | number:'':'es' }}</td>
            </tr>
        </tbody>
    </table>        
</div>      
